import { lazyLoad } from '../../utils/loadable';

export const Notifications = lazyLoad(
  () => import('./notifications'),
  (module) => module.Notifications
);
